<script setup lang="ts">
import TheHeader from "~/app/components/layout/TheHeader.vue";
import TheFooter from "~/app/components/layout/TheFooter.vue";

onErrorCaptured((err, target, info) => {
  if (err.statusCode !== 404) {
    console.error("Layout error: ", err, info);
    return false;
  }
});
</script>

<template>
  <the-header></the-header>
  <main class="main">
    <slot />
  </main>
  <the-footer></the-footer>
</template>

<style scoped>
.main {
  min-height: calc(theme(height.screen) - 20vh);
}
</style>
